// extracted by mini-css-extract-plugin
export var falconContainer = "_vo-2";
export var offerCenter = "_vo-0";
export var roktContainer = "_vo-1";